// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c659808b","453":"9df18032","732":"ab4b2ec1","977":"9aee807b"}[chunkId] + ".chunk.js";
};